import React from 'react';
import Profile from "../../assets/Profile/profile.jpg"
import { Typewriter } from 'react-simple-typewriter'
import './Banner.css'

const Banner = () => {
    return (
        <div className="hero min-h-screen banner" style={{ backgroundImage: `url("https://i.ibb.co/nQHh5yb/banner.jpg")` }}>
            <div className="hero-overlay bg-opacity-60"></div>
            <div className="hero-content text-center text-neutral-content">
                <div className="max-w-md">
                    {/* image  */}
                    <div className="avatar">
                        <div className="w-32 rounded-full ring ring-transparent ring-offset-base-100 ring-offset-2">
                            <img className='object-contain' src={Profile} alt='img' />
                        </div>
                    </div>
                    {/* name  */}
                    <h1 className="mb-5 text-5xl font-bold banner-title">ABDUR <span className='last-name'>RAHMAN</span></h1>
                    <p className="mb-5 info">I'm a
                        <span style={{ color: '#badc58', fontWeight: 'bold' }}>
                            <Typewriter
                                words={[' Front-end Developer', ' JavaScript Developer', ' React Developer', ' Web developer']}
                                loop={1 / 0}
                                cursor
                                cursorStyle='|'
                                typeSpeed={170}
                                deleteSpeed={170}
                                delaySpeed={1000}

                            />
                        </span>
                    </p>
                    <div>
                        <a href="#about" className=''>
                            <i className="fa-sharp fa-solid fa-arrow-down-long arrow animate-bounce"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;